import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

const ImageMagnifier = ({
  src,
  alt,
  showZoom,
  setShowZoom,
  wrapperClassName = "aspect-square",
}) => {

  return (
    <>
      {/* Normal Image */}
      <div
        className={`relative w-full overflow-hidden cursor-zoom-in ${wrapperClassName}`}
        onClick={() => setShowZoom(true)}
      >
        <img src={src} alt={alt} className="w-full h-full object-contain" />
      </div>

      {/* Fullscreen Zoom Modal */}
      {showZoom && (
        <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center">
          {/* Close Button */}
          <button
            onClick={() => setShowZoom(false)}
            className="absolute top-5 right-5 text-white text-3xl z-50"
          >
            ✕
          </button>

          {/* Zoomable Image */}
          <TransformWrapper
            initialScale={1}
            minScale={1}
            maxScale={4}
            doubleClick={{ mode: "zoomIn" }}
          >
            <TransformComponent>
              <img
                src={src}
                alt={alt}
                className="max-w-full max-h-screen object-contain"
              />
            </TransformComponent>
          </TransformWrapper>
        </div>
      )}
    </>
  );
};

export default ImageMagnifier;
